import { Components, Theme } from '@mui/material';

export const dividerStyles: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.customGrey.medium
    })
  }
};
